import { useState, useEffect } from "react";
import styled from "styled-components";
import TrayAmbientFG from "./TrayAmbientFG";
import HBWAmbientFG from "./HBWAmbientFG";
import CPSAmbientFG from "./CPSAmbientFG";
import Dispatch from "./Dispatch";
import { useOrientation } from "../../../hooks/useOrienttation";

// Placeholder components for others

const ContainerMain = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 1rem;
`;

const StyledHeading = styled.h5`
  color: var(--color-grey-500);
  padding-top: 1em;
  padding-left: 2em;
  margin-bottom: -1rem;
`;

const DrawerLabel = styled.label`
  font-size: 0.8em;
  margin-left: 0.5em;
`;

const Drawer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  height: 100%;
  width: 100px;
  background: rgba(0, 0, 20, 0.8);
  transform: translateX(${(p) => (p.open ? "0" : "-100%")});
  transition: transform 0.3s ease;
  padding: 1rem;
  padding-top: 4rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const DrawerItem = styled.button`
  background: none;
  border: none;
  color: #fff;
  text-align: left;
  padding: 0.5rem 0;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const MenuButton = styled.button`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 30;
  font-size: 1.8rem;
  background: none;
  border: none;
  cursor: pointer;
`;

const menuItems = [
  { key: "tray", label: "Tray Ambient", component: TrayAmbientFG },
  { key: "hbwAmbient", label: "HBW Ambient", component: HBWAmbientFG },
  { key: "cpsAmbient", label: "CPS Ambient", component: CPSAmbientFG },
  { key: "dispatch", label: "Dispatch", component: Dispatch },
];

function PageFillgrade() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState("tray");
  const [autoRotate, setAutoRotate] = useState(true);
  const orientation = useOrientation();
  const isPortrait = orientation === "portrait";
  const barHeight = isPortrait ? 389 : 189;

  const selectedItem = menuItems.find((item) => item.key === selectedKey);

  // Auto rotate every 2 minutes
  useEffect(() => {
    if (!autoRotate) return;

    const interval = setInterval(() => {
      setSelectedKey((prevKey) => {
        const currentIndex = menuItems.findIndex((i) => i.key === prevKey);
        const nextIndex = (currentIndex + 1) % menuItems.length;
        return menuItems[nextIndex].key;
      });
    }, 120000); // 2 minutes

    return () => clearInterval(interval);
  }, [autoRotate]);

  return (
    <ContainerMain>
      <MenuButton onClick={() => setMenuOpen(!menuOpen)}>☰</MenuButton>

      {menuOpen && (
        <Drawer open={menuOpen}>
          {menuItems.map((item) => (
            <DrawerItem
              key={item.key}
              onClick={() => {
                setSelectedKey(item.key);
                setMenuOpen(false);
              }}
            >
              {item.label}
            </DrawerItem>
          ))}

          <hr />
          <DrawerLabel>
            <input
              type="checkbox"
              checked={autoRotate}
              onChange={(e) => setAutoRotate(e.target.checked)}
            />
            Rotate
          </DrawerLabel>
        </Drawer>
      )}
      <StyledHeading>Fill Grade - {selectedItem.label}</StyledHeading>
      {selectedItem && <selectedItem.component height={barHeight} />}
    </ContainerMain>
  );
}

export default PageFillgrade;
